import {setupSPA} from '../utils/setupApp.js';
import PublicEventDetailApp from '../apps/registration/PublicEventDetailApp.vue';

window.SetupPublicEventDetail = (params) => setupSPA(PublicEventDetailApp, params);
